import { render, staticRenderFns } from "./UserPayinPage.vue?vue&type=template&id=7e48fe28&"
import script from "./UserPayinPage.vue?vue&type=script&lang=js&"
export * from "./UserPayinPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserPayinPage.vue"
export default component.exports